import React from "react";
import footerlogo from "../Assets/imgs/footer-logo.webp";
import arrow from "../Assets/imgs/up-arrow.webp";
import "../styles/Home.css";

const Footer = () => {
  return (
    <div>
      <div
        className="footer"
        data-aos="zoom-in"
        data-aos-easing="linear"
        data-aos-duration="500"
      >
        <div className="container">
          <div className="footer-bg">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-12">
                <div className="for-mobile-foo">
                  <div className="footer-logo">
                    <div className="logo-image">
                      <a href="#">
                        <img
                          src={footerlogo}
                          width={153}
                          height={52}
                          alt="footer-logo"
                        />
                      </a>
                    </div>
                    <div className="footer-logo-text">
                      Connecting You To Your Career Ambitions
                    </div>
                  </div>

                  <div className="footer-right-mobile">
                    <a href="#">
                      <img
                        src={arrow}
                        width={61}
                        height={61}
                        alt="footer-arrow"
                      />
                    </a>
                  </div>
                </div>
              </div>

              {/* <div className="footer-menu"> */}
              <div className=" col-lg-6 col-md-7 col-12">
                <div className="footer-menu-item">
                  <div className="footer-item">
                    <ul>
                      <li>
                        <a href="#">Home</a>
                      </li>
                      <li>
                        <a href="#featured-job">Featured jobs</a>
                      </li>
                      <li>
                        <a href="#howitwork">How it works</a>
                      </li>
                      <li>
                        <a href="#category">Job Categories</a>
                      </li>
                    </ul>
                  </div>

                  <div className="footer-item second">
                    <ul>
                      <li>
                        <a
                          href="https://www.facebook.com/jobup.mobi/"
                          target="_blank"
                        >
                          Facebook
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/jobup.mobi/"
                          target="_blank"
                        >
                          Instagram
                        </a>
                      </li>
                      {/* <li>
                        <a href="#">Linkedin</a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              {/* </div> */}

              <div className="col-lg-3 col-md-2 col-12">
                <div className="footer-right">
                  <a href="#">
                    {" "}
                    <img
                      src={arrow}
                      width={61}
                      height={61}
                      alt="footer-arrow"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="footer-last-text">
              <div className="col-lg-12">
                © 2026 JobUp. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
